export const getPlaceIconPath = (index) => {
  switch (index) {
    case 0:
      return '/img/icons/first place.png';
    case 1:
      return '/img/icons/second place.png';
    case 2:
      return '/img/icons/third place.png';
    case 3:
      return '/img/icons/place_4.png';
    case 4:
      return '/img/icons/place_5.png';
    case 5:
      return '/img/icons/place_6.png';
    default:
      return null;
  }
};